import React from 'react';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import { Link } from 'react-router-dom';
import classes from './NavigationComponent.module.scss';

export default function NavigationComponent(props) {
  const { label = '', linkBack = '', linkForward = '', children, onClick = () => {} } = props;

  return (
    <div className={classes.container}>
      {linkBack && typeof linkBack === 'string' && (
        onClick ? <WestIcon onClick={onClick} sx={{ color: '#003B58' }} />
        :
        <Link to={linkBack}>
          <WestIcon sx={{ color: '#003B58' }} />
        </Link>
      )}
      {linkBack && typeof linkBack !== 'string' && linkBack}
      <p className={classes.label}>{label}</p>
      {linkForward ? (
        <Link to={linkForward}>
          <EastIcon sx={{ color: '#003B58' }} />
        </Link>
      ) : (
        children
      )}
    </div>
  );
}
